/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

(function () {
    "use strict";

    angular
        .module("ROGER")

        //
        .controller("FinancingController", [
            "$scope", "$http", "$sessionStorage", "financing", "$messageBox", "$oidc",
            function ($scope, $http, $sessionStorage, financing, $messageBox, oidc) {

                $scope.$storage = $sessionStorage;

                $scope.financing = financing;
                $scope.isNew = financing.Id === 0 ? true : false;
                $scope.displayCancel = !$scope.isNew && (financing.StatusId === 0 || financing.StatusId === 3);

                if ($scope.financing.InsuranceGroups != null) {
                    for (var i = 0; i < $scope.financing.InsuranceGroups.length; i++) {
                        var insuranceGroup = $scope.financing.InsuranceGroups[i];
                        insuranceGroup.SelectedInsurance = $scope.isNew && insuranceGroup.InsuranceTypeId > 2 ? null : insuranceGroup.Insurances[0];
                    }
                }

                // Creates new financing request
                $scope.create = function () {
                    var insurances = [];
                    if ($scope.financing.InsuranceGroups != null) {
                        for (var i = 0; i < $scope.financing.InsuranceGroups.length; i++) {
                            if ($scope.financing.InsuranceGroups[i].SelectedInsurance != null) {
                                insurances.push($scope.financing.InsuranceGroups[i].SelectedInsurance.Id);
                            }
                        }
                    }

                    return $http
                        .put("/api/financing/create", {}, {
                            params: {
                                retailerId: $scope.$storage.retailer.Id,
                                invoiceId: $scope.financing.InvoiceId,
                                requestNote: $scope.financing.RequestNote != null ? $scope.financing.RequestNote : "",
                                period: $scope.financing.Period != null ? $scope.financing.Period : "",
                                insuranceIds: insurances
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function () {
                            $scope.$close();
                        }, function () {
                            $scope.$dismiss();
                        });
                };

                // Cancels financing request
                $scope.cancel = function () {
                    return $messageBox
                        .showConfirm("CancelFinancing", "CancelFinancingConfirm", "CancelFinancing")
                        .result
                        .then(function () {
                            return $http
                                .put("/api/financing/cancel", {}, {
                                    params: {
                                        retailerId: $scope.$storage.retailer.Id,
                                        financingId: $scope.financing.Id
                                    },
                                    headers: {
                                        Authorization: oidc.current.token_type + " " + oidc.current.access_token
                                    }
                                })
                                .then(function () {
                                    $scope.$close();
                                }, function () {
                                    $scope.$dismiss();
                                });
                        });
                };
            }
        ]);

})();